// Config declarativa: username -> descriptor de vista.
//
// Cada entrada es uno de estos dos tipos (mismo shape que
// src/router/genericDashboardRoutes.js para el caso "report"):
//   { type: "swagger", docs: [{ key, label, url }] }
//   { type: "report", reportName: string, params: object }
//
// Agregar un usuario nuevo es agregar un objeto acá, sin tocar
// specialUserView.js.
export const SPECIAL_USER_VIEWS = {
  "user@gallion": {
    type: "swagger",
    docs: [
      { key: "gallion", label: "API Gallion", url: "/swagger_gallion.yaml" },
    ],
  },
  "user@sisargentina": {
    type: "swagger",
    docs: [
      { key: "sis", label: "API SIS", url: "/swagger_sis.yaml" },
      {
        key: "link-sale",
        label: "Venta por Link",
        url: "/swagger_link-sale.yaml",
      },
    ],
  },
  "user@social-gateway": {
    type: "swagger",
    docs: [
      {
        key: "social-gateway",
        label: "API Social Gateway",
        url: "/swagger_social-gateway.yaml",
      },
    ],
  },
  "user@triunfo-ap": {
    type: "swagger",
    docs: [
      {
        key: "triunfo-ap",
        label: "API Triunfo AP",
        url: "/swagger_triunfo-ap.yaml",
      },
    ],
  },
  "ventas-asesora": {
    type: "report",
    reportName: "Ventas por link",
    params: { canal: "TMOTOS" },
  },
  "user@mkt": {
    type: "report",
    reportName: "RegistroAltasMensualesVD",
    params: {
      canal: ["Mediline"],
      seller_tokens: ["ScaMuRjfC12CzZ6ZBTXr", "4N9SKXdZs18t3A764qUZ"],
    },
  },
};

// Resuelve la vista de un usuario ROLE_USER a partir de su username completo
// (tal cual está guardado en localStorage). Devuelve null cuando no hay
// mapeo registrado, incluyendo un username sin registrar que comparte
// dominio con uno registrado (ver design.md D2).
export const resolveSpecialUserView = (username) => {
  if (!username) return null;
  return SPECIAL_USER_VIEWS[username] || null;
};
